import React, { useEffect } from 'react';

import LeaveStyleStudioEventNotificationView from './LeaveStyleStudioEventNotificationView';
import {
  useMessageData,
  useNotification,
} from '@components/Notification/hooks';

import { IEventNotification } from './interfaces';

const LeaveStyleStudioEventNotification = React.forwardRef<
  HTMLDivElement,
  Omit<IEventNotification, 'ref'>
>(
  (
    { id, message, type, onLeave, onCancel, setHideCurrentlyOpenOverlays },
    ref,
  ) => {
    const { hideNotification } = useNotification();
    const { color, colorIcon, background, icon } = useMessageData(type);

    const handleHide = () => hideNotification(id);

    useEffect(() => {
      if (setHideCurrentlyOpenOverlays) {
        setHideCurrentlyOpenOverlays(true);
      }

      return () => {
        if (setHideCurrentlyOpenOverlays) {
          setHideCurrentlyOpenOverlays(false);
        }
      };
    }, [setHideCurrentlyOpenOverlays]);

    return (
      <LeaveStyleStudioEventNotificationView
        ref={ref}
        message={message}
        color={color}
        colorIcon={colorIcon}
        icon={icon}
        background={background}
        onLeave={() => {
          handleHide();
          onLeave();
        }}
        onClickClose={() => {
          handleHide();
          onCancel();
        }}
      />
    );
  },
);

LeaveStyleStudioEventNotification.displayName =
  'LeaveStyleStudioEventNotification';

export default LeaveStyleStudioEventNotification;
